import React from 'react';
import { Badge } from '../components/ui/badge';
import { ScrollArea } from '../components/ui/scroll-area';
import { Button } from '../components/ui/button';
import { projectsApi } from '../lib/api';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export function QuotesPanel({ quotes, onCardClick, onRefresh }) {

  const handlePromote = async (e, projectId) => {
    e.stopPropagation();
    try {
      await projectsApi.promote(projectId);
      toast.success('Quote promoted to active project');
      onRefresh();
    } catch (err) {
      toast.error('Failed to promote quote');
      void err;
    }
  };

  return (
    <div className="bg-[#1E1530] border-2 border-[#7C3AED]/20 rounded-2xl p-3 h-full" data-testid="quotes-panel">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className="w-2.5 h-2.5 rounded-full bg-[#7C3AED]" />
          <h3 className="font-bold text-[#F0EDE8] tracking-tight text-sm">Quotes</h3>
        </div>
        <Badge variant="secondary" className="bg-[#2D1F4E] text-[#A78BFA] rounded-lg text-xs h-5">
          {quotes.projects.length}
        </Badge>
      </div>
      <p className="text-[10px] text-[#A78BFA]/60 mb-2">Potential projects — promote to make active</p>
      <ScrollArea className="h-[160px]">
        <div className="space-y-1.5">
          {quotes.projects.map((project) => (
            <div key={project.id}
              className="bg-[#2D1F4E]/50 border border-[#7C3AED]/15 rounded-lg p-2 cursor-pointer hover:bg-[#2D1F4E] transition-colors"
              onClick={() => onCardClick(project)}
              data-testid={`quote-card-${project.id}`}>
              <p className="text-[10px] uppercase tracking-wide text-[#A78BFA]/70 mb-0.5">{project.client_name}</p>
              <p className="text-xs font-medium text-[#F0EDE8] truncate">{project.title}</p>
              <div className="flex items-center justify-between mt-1.5" onClick={(e) => e.stopPropagation()}>
                <span className="text-[10px] text-[#A78BFA]/50">
                  {new Date(project.created_at).toLocaleDateString()}
                </span>
                <Button variant="ghost" size="sm"
                  onClick={(e) => handlePromote(e, project.id)}
                  className="h-5 px-1.5 text-[#A78BFA] hover:bg-[#7C3AED]/20 rounded-md text-[10px]"
                  data-testid={`promote-quote-${project.id}`}>
                  Activate<ArrowRight className="w-3 h-3 ml-0.5" />
                </Button>
              </div>
            </div>
          ))}
          {quotes.projects.length === 0 && (
            <div className="text-center py-8 text-[#A78BFA]/40">
              <p className="text-sm">No pending quotes</p>
              <p className="text-xs mt-1">Create a project as a &quot;Quote&quot; to add here</p>
            </div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
